import * as actions from '../actions';

var defaultState = null;

export default function user(state = defaultState, action) {
    switch (action.type) {

        case actions.USER_GET_ONE:
            var newState = state;
            if (!action.error) {
                newState = action.payload.data;
            }
            return newState;

        default:
            return state;

    }
}
